import React, { useEffect, useRef, useState } from "react";
import { Bell, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import useNotificationStream from "../../pages/realTimeAnalytics/useNotificationStream";
import AlertsPanel from "../../pages/realTimeAnalytics/components/AlertsPanel";
import useAnalyticsBatches from "../analytics/useAnalyticsBatches";
import { usePlantSelection } from "../../features/plants/PlantSelectionContext";

const NotificationContent = () => {
  const { selectedPlantId } = usePlantSelection();
  const notifications = useNotificationStream();
  const batches = useAnalyticsBatches(selectedPlantId);
  const batchIds = new Set(batches.rows.map(batch => batch.batchId));
  return <AlertsPanel alerts={notifications.alerts.filter(alert => batchIds.has(alert.batchId))} batches={batches.rows} isLoading={notifications.isLoading || batches.isLoading} error={notifications.error || batches.error} onMarkAsRead={notifications.markAsRead} />;
};

const NotificationMenu = () => {
  const [open, setOpen] = useState(false);
  const container = useRef(null);
  const trigger = useRef(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!open) return;
    const dismiss = event => { if (!container.current?.contains(event.target)) setOpen(false); };
    const escape = event => { if (event.key === "Escape") { setOpen(false); trigger.current?.focus(); } };
    document.addEventListener("pointerdown", dismiss);
    document.addEventListener("keydown", escape);
    return () => { document.removeEventListener("pointerdown", dismiss); document.removeEventListener("keydown", escape); };
  }, [open]);
  return <div ref={container}>
    <button ref={trigger} type="button" aria-label="View alerts" aria-expanded={open} aria-controls="global-alerts" onClick={() => setOpen(value => !value)} className="rounded-full p-2 text-slate-500 hover:bg-lightSecondary hover:text-brand"><Bell className="h-5 w-5" /></button>
    {open && <section id="global-alerts" aria-label="Notifications" className="fixed right-3 top-20 z-[90] max-h-[calc(100dvh-6rem)] w-[calc(100vw-1.5rem)] max-w-sm overflow-y-auto rounded-xl border border-slate-100 bg-white p-2 shadow-xl"><div className="flex justify-end"><button type="button" aria-label="Close alerts" onClick={() => { setOpen(false); trigger.current?.focus(); }} className="rounded p-1 text-slate-500 hover:bg-slate-100"><X className="h-4 w-4" /></button></div><NotificationContent /></section>}
  </div>;
};
export default NotificationMenu;
